/* import __COLOCATED_TEMPLATE__ from './reviewable-field.hbs'; */
import Component from "@ember/component";

export default Component.extend({});
